import React from 'react'
import { Redirect, useParams } from '@fs/zion-router'
import { colors } from '@fs/zion-ui'
import { kebabCase } from 'lodash'

import BaybayinSection from './components/BaybayinSection'
import CatalogoSection from './components/Catalogo/CatalogoSection'
import LeadSection from './components/LeadSection'
import RecordMapSection from './components/RecordMap/RecordMapSection'
import useSurnameRecordData from './hooks/useSurnameRecordData'
import footerMobileBgImage from './images/footer-bg-mobile.svg'
import footerBgImage from './images/footer-bg.svg'
import socialImage from './images/ph-surname-social.jpg'
import {
  FooterSection,
  SurnameCountriesSection,
  SurnameSearchSection,
  SurnameTreePersonSection,
} from '../../../../components/section-templates'
import RegionPage from '../../../../pages/RegionPage'
import { formatSurname } from '../../utils/text-formatting'

export default function NewSurnamePage() {
  const { surname } = useParams()

  const formattedSurname = formatSurname(surname)
  const { data: recordData, isLoading } = useSurnameRecordData(formattedSurname)
  const { provinces, treeRecordsTotal, catalogo } = recordData || {}

  if (!formattedSurname) return <Redirect to="/surname" />

  return (
    <RegionPage
      usabillaURL="//w.usabilla.com/0fe3df97b62f.js"
      pageDetails={['Philippines', 'SurnamePage', 'v2025.10', kebabCase(surname)]}
      pageMetadata={{
        title: `${formattedSurname} - Your Filipino Surname. Free Filipino Genealogy.`,
        description: `Learn about your Filipino surname, ${formattedSurname}, and its potential origin. Was it assigned from the Catálogo alfabético de Apellidos, or does it have some other origin?`,
        keywords: 'Filipino surname, last name, Filipino last name, surname',
        canonicalLink: '/en/philippines/surname/',
        imageSrc: socialImage,
        imageWidth: 1200,
        imageHeight: 630,
      }}
    >
      <LeadSection surname={formattedSurname} recordCount={treeRecordsTotal} />
      <CatalogoSection surname={formattedSurname} catalogoData={catalogo} />
      <RecordMapSection isLoading={isLoading} provinces={provinces} surname={formattedSurname} />
      <BaybayinSection surname={formattedSurname} />
      <SurnameTreePersonSection
        surname={formattedSurname}
        subtitle={`Click any of the people listed here or see more to find ${formattedSurname} family members in the FamilySearch database.`}
        backgroundColor={colors.gray00}
        showFades
      />
      <SurnameCountriesSection surname={formattedSurname} countryColor="blue" backgroundColor={colors.gray02} />
      <SurnameSearchSection backgroundColor={colors.gray00} />
      <FooterSection
        title="Start building your family tree today."
        subtitle="Enjoy all the features of FamilySearch with a free account."
        color={colors.blue03}
        bgImage={footerBgImage}
        mobileBgImage={footerMobileBgImage}
      />
    </RegionPage>
  )
}
